/**
 * v0.3
 * @author Gabe Rose (gabe@equisolve.com)
 * This plugin is used to generate and configure charts dynamically via an HTML data
 * attribute interface.
 **/
function ChartBuilder (el) {
    var apiUrl = '/api/v1/chart-data';
    var self = this;
    this.el = el;
    this.cid = el.getAttribute('data-cid');
    this.pid = el.getAttribute('data-pid');
    this.name = el.getAttribute('data-chart-name');
    this.type = el.getAttribute('data-chart-type');
    this.fieldName = el.getAttribute('data-field-name');
    this.unitType = el.getAttribute('data-unit-type');
    this.donutSolid = el.getAttribute('data-donut-solid') == 'true' ? true : false;
    this.isFinancialChart = el.getAttribute('data-financial-chart');
    this.hideToolTip = el.getAttribute('data-hide-tooltip');
    this.legend = el.getAttribute('data-legend') === 'true' ? true : false;
    this.extraOptionsId = el.getAttribute('data-extra-options-id');
    this.unitScale = el.getAttribute('data-unit-scale');
    this.width = el.getAttribute('data-width');
    this.data = {};
    this.chart = {};
    
    function nextValue(num) { 
      return p[(jq.inArray(num, p) + 1) % p.length]; 
    }
    
    function getOptions() {
        var opts = {};
        if (self.type == 'pie') {
            opts = {
                height: 220,
                donut: true,
                donutWidth: 50,
                donutSolid: self.donutSolid,
                showLabel: false,
                plugins: [
                    // Chartist.plugins.ctPieLabels({
                    //     labelInterpolationFnc: function (value, totalValueSum) {
                    //         return Math.round((value / totalValueSum) * 100) + '%';
                    //     }
                    // }),
                    Chartist.plugins.legend({
                        clickable: false,
                        position: jq(self.el).parent().find('.ct-legend-wrapper')[0] ? jq(self.el).parent().find('.ct-legend-wrapper')[0] : 'bottom'
                    }),
                    Chartist.plugins.tooltip({
                        appendToBody: true,
                        transformTooltipTextFnc: function (value) {
                            return value + '%';
                        }
                    }),
                ]
            };
        }else {
            opts = {
                height: 250,
                width: self.width,
                distributeSeries: true,
                axisX: {
                    showGrid: false,
                },
                axisY: {
                    showGrid: false,
                    showLabel: false,
                    offset: 0
                },
                seriesBarDistance: 15,
                plugins: [
                    Chartist.plugins.ctBarLabels({
                        labelInterpolationFnc: function (text) {
                            if (self.unitType == 'currency') {
                                var value = parseFloat(text);
                                if (self.unitScale == 'M') {
                                    var value = parseFloat(text) * 1000 / 1000000
                                }
                                return '$' + value.toLocaleString('en-US', {minimumFractionDigits: 0, maximumFractionDigits: 1});
                            }
                            return text.toLocaleString();
                        },
                        position: {
                            y: function (data) {
                                return data.y2 - 10;
                            }
                        }
                    }),  
                    Chartist.plugins.tooltip({
                        appendToBody: true,
                        transformTooltipTextFnc: function (value) {
                            // Define previous value function 
                            // This will give us the previous value in a defined array
                            function previousValue (num, arr) { 
                                if (num && arr) {
                                    return arr[(jq.inArray(num, arr) - 1 + arr.length) % arr.length];
                                }
                            }
                            
                            if (self.hideToolTip !== 'true') {
                                // Ensure value is an int
                                var valueNum = parseFloat(value);
                                
                                // Iterate over our array of strings with map() and change it to numbers
                                var valueArray = self.data.series.map(Number);
                                
                                // Grab the position of the value in the array
                                var valueIndex = valueArray.indexOf(valueNum);
                                
                                // If the value is not the first position in our valueArray
                                if (valueIndex !== 0) {
                                    // Define previous and current years
                                    var previousYear = previousValue(valueNum, valueArray);
                                    var currentYear = valueNum;
                                    
                                    // Define year over year logic
                                    var yoyValue = ((currentYear - previousYear) / previousYear) * 100;
                                
                                    return yoyValue.toFixed(1) + '% y/y';
                                }
                            } else {
                                return;
                            }
                        }
                    }),
                ]
            }
            if (self.legend) {
                opts.plugins.push(Chartist.plugins.legend({
                    clickable: false,
                    position: jq(self.el).parent().find('.ct-legend-wrapper')[0] ? jq(self.el).parent().find('.ct-legend-wrapper')[0] : 'bottom'
                }));
            }
        }
        return opts;
    }
    
    
    function registerHandlers ()
    {
        self.chart.on('draw', function (event) {
            // X-axis label centering fix for IE11
            // Space out bar columns: each bar takes 50% of its column slot, the rest is gap
            if (event.type === 'bar') {
                var slot = event.axisX.stepLength || (event.chartRect.width() / self.data.labels.length);
                event.element.attr({
                    style: 'stroke-width: ' + Math.max(slot * 0.5, 1) + 'px'
                });
            }
            // X-axis lab
            if (event.type === 'label' && event.axis && event.axis.units.pos === 'x') {
                if (!self.chart.supportsForeignObject) {
                    //console.log(event);
                    event.element.attr({
                        x: event.x + (event.width / 2) - 15,
                        'text-anchor': 'middle'
                    });
                }
            }
        });
        jq('.nav a').on('shown.bs.tab', function (e) {
            //console.log('tab shown');
            var target = jq(this).attr('href');
            
            if (jq(target).find(self.el).length > 0) {
                //console.log('update chart');
                self.chart.update();
            }
        });
    }
    
    function getChartData () {
        return new Promise(function (resolve, reject) {
            var url = new URL(window.location.protocol + '//' + window.location.hostname + apiUrl),
            params = {
                cid: self.cid,
                pid: self.pid,
                chart_name: self.name,
                field_name: self.fieldName,
                is_financial_chart: self.isFinancialChart,
                tooltip_hidden: self.hideToolTip
            };
            Object.keys(params).forEach(function (key) {
                url.searchParams.append(key, params[key]);
            });
            console.log(url);
            fetch(url).then(function (response) {
                return response.json();
            }).then(function (results) {
                var resultsData = results.data.map(function (el, i) {
                        return el.match(/[\d.]+/g)[0];
                    });
                    self.data.series = resultsData;
                    self.data.labels = results.labels;
                    // Holds full value strings to use in the legend
                    self.data.labelValues = results.data;
                    if (self.legend) {
                        //If there's a legend, transform the labels.
                        self.data.labels = results.labels.map(function (el, i) {
                                var prefix = '';
                                if (self.unitType == 'percentage') {
                                    prefix = '<span class="percent">' + self.data.series[i] + '%</span>';
                                } else if (self.unitType == 'currency') {
                                    prefix = '<span class="currency">$' + self.data.labelValues[i] + '</span> ';
                                    if (self.unitScale == 'M') {
                                        el = el / 1000000
                                        el = el.toFixed(2);
                                    }
                                }
                                return prefix  + el;
                        });
                    }
                    //console.log(self.data);
                resolve();
            });
        });
    }
    getChartData().then(function () {
      // We allow for entirely custom options to be passed via a JSON script.
      var customOpts = {};  
      if (document.getElementById(self.extraOptionsId)) {
          customOpts = JSON.parse(document.getElementById(self.extraOptionsId).innerHTML);
      }
      var opts = Object.assign({}, getOptions(), customOpts);
      if (self.type == 'pie') {
          self.chart = new Chartist.Pie(self.el, self.data, opts);
      }else {
          self.chart = new Chartist.Bar(self.el, self.data, opts);
      }
      registerHandlers();
    });
}

var charts = document.querySelectorAll('.chartist-chart')
if (charts.length) {
    charts.forEach(function (el) {
        new ChartBuilder(el);
    });
}